<template>
  <div id="issue-tracker-widget">
    <v-container>
      <v-card light>
        <v-toolbar color="primary">
          <v-toolbar-title style="color:white">Issue Tracker</v-toolbar-title>
          <add-issue-dialog
            :color="color"
            :dark="true"
            :small="small"
            :bottom="bottom"
            :right="right"
            :absolute="absolute"
            :fab="fab"
            :icon="icon"
            :flat="flat"
          />
        </v-toolbar>
        <issue-list></issue-list>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import IssueFormDialog from '../../../components/dialogs/AddIssueForm'
import IssueList from '../lists/IssueList.vue'

export default {
  data () {
    return {
      color: 'accent',
      dark: true,
      small: true,
      bottom: true,
      right: true,
      absolute: true,
      fab: true,
      icon: 'add',
      flat: false
    }
  },
  components: {
    'add-issue-dialog': IssueFormDialog,
    'issue-list': IssueList
  },
  methods: {
    getIssues: function () {
      return this.$store.getters.issues
    }
  },
  computed: {
    issues: function () {
      return this.getIssues()
    }
  },
  watch: {
    issues: function () {
      // Respond when the issues computed property changes
      console.log("issues changed")
      console.log(this.issues)
    }
  },
  mounted () {
    console.log(this.issues)
  }
}
</script>




// WEBPACK FOOTER //
// src/layouts/dashboard/widgets/IssueTracker.vue